module.exports = __webpack_public_path__ + "static/template_ocean-ec089edb422b4f9d98498a9033f69fea.png";